module.exports = __webpack_public_path__ + "static/media/hospitalisation.4532fb45.svg";